<template>
  <a-menu-item key="updatePersonalNo" @click="showUpdatePersonalNoModal">
    <HighlightOutlined />&nbsp;修改證件編號&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="650px" title="修改證件編號" :maskClosable="isMaskClosable" 
        :closable="isMaskClosable" :cancelButtonProps="cancelButtonProps" :confirm-loading="isSavingPersonalNo" 
        okText="修改" cancelText="關閉" @cancel="cancelPersonalNoUpdate" @ok="savePersonalNoUpdate">
    <a-divider />
    <a-form ref="updatePersonalNoForm" :model="formState" name="basic" :rules="formRules" :label-col="{ span: 5 }" 
        :wrapper-col="{ span: 13 }" :disabled="isSavingPersonalNo">
      <a-form-item ref="currentPersonalNo" label="原證件編號" name="currentPersonalNo">
        <a-input v-model:value="formState.currentPersonalNo" disabled style="width: 85%"/>
      </a-form-item>
      <a-form-item ref="updatedPersonalNo" label="證件編號" name="updatedPersonalNo">
        <a-input v-model:value="formState.updatedPersonalNo" style="width: 85%"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { HighlightOutlined } from '@ant-design/icons-vue';
import { ref, reactive, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';
import common from "@/common";
import config from "@/config";

const props = defineProps(['projectUrl', 'projectQuestUser']);

const updatePersonalNoForm = ref();
const isOpen = ref(false);
const formState = reactive({});
const isMaskClosable = ref(false);
const isSavingPersonalNo = ref(false);
const cancelButtonProps = ref({
  disabled: isSavingPersonalNo
});

const emit = defineEmits(['cancel', 'submit-success']);

const getUserQuestTypes = () => {
    return common.postRequestWithPromise(config.mgmtProjectQuestUserQuestType, {
        projectUrl: props.projectUrl,
        personalNo: formState.updatedPersonalNo
    });
}

const formRules = {
    updatedPersonalNo: [{
        required: true,
        trigger: [],
        validator: (rule, value) => {
            if (common.isEmpty(value)) {
                return Promise.reject('請輸入證件編號');
            }
            if (value.length < 10) {
                return Promise.reject('請輸入完整之證件編號');
            }
            return new Promise((resolve, reject) => {
                getUserQuestTypes()
                .then((response) => {
                    if (response.data.questTypes == null || 
                            !Array.isArray(response.data.questTypes)) {
                        reject("資料回傳格式有誤 請洽詢廠商");
                        return ;
                    }
                    if (response.data.questTypes.length === 0) {
                        resolve();
                        return ;
                    }
                    reject("無法修改為已存在的證件編號");
                }).catch(() => reject("修改證件編號 發生錯誤 請洽詢廠商"));
            });
        }
    }]
};

const showUpdatePersonalNoModal = () => {
  if (updatePersonalNoForm.value != null) {
    updatePersonalNoForm.value.resetFields();
  }
  formState.currentPersonalNo = props.projectQuestUser.personalNo;
  formState.updatedPersonalNo = null;
  setTimeout(() => isOpen.value = true, 100);
}

const cancelPersonalNoUpdate = () => {
  isOpen.value = false;
  emit('cancel');
}

const savePersonalNoUpdate = () => {
  isSavingPersonalNo.value = true;
  updatePersonalNoForm.value.validate()
  .then(() => {
    common.openConfirmModalByActions(550, '修改確認', "是否確認修改以下內容：\n" + 
      "原證件編號「" + formState.currentPersonalNo + "」\n" + 
      "修改為「" + formState.updatedPersonalNo + "」", () => {
        common.postRequest(config.mgmtProjectQuestUpdateUnImport, {
          projectUrl: props.projectUrl,
          currentPersonalNo: formState.currentPersonalNo,
          updatedPersonalNo: formState.updatedPersonalNo
        }, () => {
          isSavingPersonalNo.value = false;
          message.success("證件編號修改成功");
          isOpen.value = false;
          emit('submit-success', formState, props.projectQuestUser);
        }, () => {
          isSavingPersonalNo.value = false;
        });
      }, () => isSavingPersonalNo.value = false);
  }).catch(() => isSavingPersonalNo.value = false);
}
</script>


